import { render } from "./SideBarMovilCliente.vue?vue&type=template&id=dcc96cd0"
import script from "./SideBarMovilCliente.vue?vue&type=script&lang=js"
export * from "./SideBarMovilCliente.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/monitor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__